import { FC, useMemo, useState } from 'react';
import { IoIosPause } from 'react-icons/io';

import Button, { ButtonVariants } from '@/components/new-design/Button';
import { COLORS } from '@/constants/COLORS';
import FastBackwardIcon from '@/pages/replay/components/FastBackwardIcon/FastBackwardIcon';
import FastForwardIcon from '@/pages/replay/components/FastForwardIcon/FastForwardIcon';
import PlayIcon from '@/pages/replay/components/PlayIcon/PlayIcon';
import SkipBackwardIcon from '@/pages/replay/components/SkipBackwardIcon/SkipBackwardIcon';
import SkipForwardIcon from '@/pages/replay/components/SkipFowardIcon/SkipFowardIcon';

import styles from './ReplayActionsButtons.module.css';

interface ReplayActionsButtonsProps {
  onClickPlay: () => void;
  onClickPause: () => void;
  onClickSkipForward: () => void;
  onClickSkipBackward: () => void;
  onClickFastForward: () => void;
  onClickRewind: () => void;
}

const ReplayActionsButtons: FC<ReplayActionsButtonsProps> = ({
  onClickFastForward,
  onClickSkipForward,
  onClickSkipBackward,
  onClickRewind,
  onClickPlay,
  onClickPause,
}) => {
  const [isPlaying, _] = useState(false); //TODO Check how to handle this, maybe it could be a prop

  const buttons = useMemo(() => {
    const iconProps = { width: 20, height: 20, color: COLORS.white50 };

    return [
      { icon: <SkipBackwardIcon {...iconProps} />, onClick: onClickSkipBackward },
      { icon: <FastBackwardIcon {...iconProps} />, onClick: onClickRewind },
      {
        icon: isPlaying ? <IoIosPause /> : <PlayIcon />,
        onClick: isPlaying ? onClickPause : onClickPlay,
      },
      { icon: <FastForwardIcon {...iconProps} />, onClick: onClickFastForward },
      { icon: <SkipForwardIcon {...iconProps} />, onClick: onClickSkipForward },
    ];
  }, [
    isPlaying,
    onClickFastForward,
    onClickPause,
    onClickPlay,
    onClickRewind,
    onClickSkipBackward,
    onClickSkipForward,
  ]);

  return (
    <div className={styles.container}>
      {buttons.map((button) => (
        <Button
          onClick={button.onClick}
          variant={ButtonVariants.transparentWithBorderRounded}
          className="flex !w-[5em] items-center justify-center"
        >
          {button.icon}
        </Button>
      ))}
    </div>
  );
};

export default ReplayActionsButtons;
